/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Rate } from '../../../../../base/enums';
import { City } from '../../../../../base/interfaces/config';
import { GetVacancyListParams } from '../../api/interfaces';
import { Recommendations, Responses } from '../../interfaces';

export interface VacancyListItem {
    id: string;
    name: string;
    isActive: boolean;
    isUpgraded: boolean;
    forWorkers: boolean;
    forRecruiters: boolean;
    rateType: Rate;
    rateFrom: string;
    rateTo: string;
    currencyId: number;
    updatedAt: Date;
    responses: Responses;
    recommendations?: Recommendations;
    views: number;
    city: City;
}

export interface VacancyListState {
    vacancies: VacancyListItem[];
    totalCount: number;
    currentPage: number;
    pageCount: number;
    shouldReloadLastFilter: boolean;
}

const initialState: VacancyListState = {
    vacancies: [],
    totalCount: 0,
    currentPage: 1,
    pageCount: 1,
    shouldReloadLastFilter: false,
};

export const vacancyListSlice = createSlice({
    name: 'employer__vacancy-list',
    initialState,
    reducers: {
        fetchVacancyList: {
            reducer: () => {},
            prepare: (params: GetVacancyListParams) => ({ payload: params }),
        },
        setVacancyList: (
            state,
            action: PayloadAction<{
                data: VacancyListItem[];
                totalCount: number;
                currentPage: number;
                pageCount: number;
            }>,
        ) => {
            state.vacancies = action.payload.data;
            state.totalCount = action.payload.totalCount;
            state.currentPage = action.payload.currentPage;
            state.pageCount = action.payload.pageCount;
        },
        setShouldReloadLastFilter: (state, action: PayloadAction<boolean>) => {
            state.shouldReloadLastFilter = action.payload;
        },
        closeVacancyRequest: {
            reducer: () => {},
            prepare: (id: string) => ({ payload: id }),
        },
        openVacancyRequest: {
            reducer: () => {},
            prepare: (id: string) => ({ payload: id }),
        },
        renewVacancyRequest: {
            reducer: () => {},
            prepare: (id: string) => ({ payload: id }),
        },
        upgradeVacancyRequest: {
            reducer: () => {},
            prepare: (vacancyId: string, packageId: string) => ({ payload: { vacancyId, packageId } }),
        },
    },
});

export const vacancyListActions = vacancyListSlice.actions;
export const vacancyListReducer = vacancyListSlice.reducer;
